// extracted by mini-css-extract-plugin
export default {"input":"ModalEditarFacturacionAlumno_input__7dO34"};